import { ClientFeedbackIconsType } from "./ClientFeedback.types";

export const feedbackIcons: ClientFeedbackIconsType[] = [
  {
    src: "/icons/client-feedback/angry.svg",
    alt: "angry",
    rating: 1,
  },
  {
    src: "/icons/client-feedback/sad.svg",
    alt: "sad",
    rating: 2,
  },
  {
    src: "/icons/client-feedback/speechless.svg",
    alt: "speechless",
    rating: 3,
  },
  {
    src: "/icons/client-feedback/smile.svg",
    alt: "smile",
    rating: 4,
  },
  {
    src: "/icons/client-feedback/satisfied.svg",
    alt: "satisfied",
    rating: 5,
  },
];
